import { makeStyles } from '@material-ui/core/styles';

export const useStyles = makeStyles(
  () => ({
    root: {
      boxShadow: '0px 1px 18px -3px rgba(115, 136, 189, 0.14)',
    },
  }),
  { name: 'PanelWelcome' }
);
